import { saveAs } from "file-saver";
import api from "./api";

export async function startProjectExportJob(projectId) {
  const response = await api.post(`/projects/${projectId}/export-jobs`);
  return response?.data?.job || null;
}

export async function getProjectExportJob(projectId, jobId) {
  const response = await api.get(`/projects/${projectId}/export-jobs/${jobId}`);
  return response?.data?.job || null;
}

export async function listProjectExportJobs(projectId, limit = 10) {
  const response = await api.get(`/projects/${projectId}/export-jobs`, {
    params: { limit },
  });
  return Array.isArray(response?.data?.jobs) ? response.data.jobs : [];
}

export async function deleteProjectExportJob(projectId, jobId) {
  const response = await api.delete(`/projects/${projectId}/export-jobs/${jobId}`);
  return response?.data?.job || null;
}

export async function downloadProjectExportJob(projectId, jobId, fallbackName = "project-dossier.zip") {
  const response = await api.get(`/projects/${projectId}/export-jobs/${jobId}/download`, {
    responseType: "blob",
  });

  const contentDisposition = String(response?.headers?.["content-disposition"] || "");
  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  const fileName = (match?.[1] || fallbackName).trim();

  saveAs(response.data, fileName || fallbackName);
}
